import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./OfflineMarketingInfo.css";
import offlineMarketingImg from '../../assets/gallery-12.jpeg';

const OfflineMarketingInfo = () => {
  return (
    <section className="info">
      <Container className="company-info">
        <Row>
          <Col lg={8} className="slide-in-left">
            <h1 className="text-primary2 fw-bold mb-4 text-center text-lg-start">Event Activities</h1>
            <Row className="align-items-center">
              <Col xs={12} md={6} className="text-center mb-4 mb-md-0">
                <img
                  src={offlineMarketingImg}
                  alt="Offline Marketing"
                  className="img-fluid company-image"
                />
              </Col>
              <Col xs={12} md={6} className="text-white">
                <h4 className="text-white mb-3 text-center text-md-start">
                  Event Activities Services
                </h4>
                <ul className="event-services-list ps-3">
                  <li>Hoardings</li>
                  <li>Canter</li>
                  <li>Cab Branding</li>
                  <li>Bus Branding</li>
                  <li>Auto Branding</li>
                  <li>Bus Shelter</li>
                  <li>Flair Printing</li>
                  <li>Newspaper Insert</li>
                  <li>Society Activation</li>
                  <li>Corporate Activation</li>
                </ul>
              </Col>
            </Row>
            <p className="text-white mt-4">
              Zarinova Entertainment excels in delivering outstanding offline marketing services
              designed to amplify your brand's presence and engagement. Our team of seasoned marketing
              professionals specializes in crafting strategic campaigns that connect with your target
              audience in meaningful ways. Whether you're looking to boost brand awareness, launch a
              new product, or drive attendance to an event, Zarinova Entertainment offers tailored
              solutions that get results. Our comprehensive services include print advertising, direct
              mail, outdoor advertising, promotional events, and experiential marketing.
            </p>
          </Col>

          <Col lg={4} className="slide-in-right">
            <Card className="get-in-touch-card mt-4">
              <Card.Body>
                <h5 className="fw-bold text-white">GET IN TOUCH</h5>
                <p className="small text-white">
                  PLEASE FILL THE FORM FOR ANY QUERY OR SUGGESTION
                </p>
                <Form>
                  <Form.Group className="mb-3" controlId="formFullName">
                    <Form.Control type="text" placeholder="FULL NAME" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Control type="email" placeholder="EMAIL ADDRESS" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formComment">
                    <Form.Control as="textarea" rows={3} placeholder="YOUR COMMENT" />
                  </Form.Group>

                  <Button
                    variant="warning1"
                    className="learn-more-btn rounded-pill px-4 py-2 text-white w-100"
                    type="submit"
                  >
                    SUBMIT
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default OfflineMarketingInfo;
